import React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import GetName from 'utils/getName';
import getSi from 'utils/getSi';
import updateHealthIssuesAnswers from 'utils/updateHealthIssuesAnswers';
import updateQuizInfo, { getQuizInfo } from 'utils/updateQuizInfo';
import DotDetails from '../DotDetails/DotDetails';
import DotSelector from '../DotSelector/DotSelector';
import QuizSlideHeading from '../QuizSlideHeading/QuizSlideHeading';
import QuizSlideNavigation from '../QuizSlideNavigation/QuizSlideNavigation';

const QuizAnxietyTwo = () => {
  const navigate = useNavigate();
  const si = getSi();

  const [name, setName] = useState('');
  const contextName = useSelector((state) => state.quiz.name);
  const dispatch = useDispatch();

  useEffect(() => {
    const dogName = async () => {
      if (contextName) {
        setName(contextName);
      } else {
        const n = await GetName(si, dispatch);
        setName(n);
      }
    };
    dogName();
  }, [si]);

  useEffect(() => {
    const info = getQuizInfo();
    if (info?.stress_and_anxiety_q2) {
      setOption(info.stress_and_anxiety_q2);
    }
  }, []);

  useEffect(() => {
    if (si) {
      updateQuizInfo({ slide: 'anxiety-2' });
    } 
  }, [si]);

  const [option, setOption] = useState(1);

  const dotSelectorData = [{ name: 1 }, { name: 2 }, { name: 3 }];
  const handleClick = () => {
    if (option) {
      updateQuizInfo({ stress_and_anxiety_q2: option });
      updateHealthIssuesAnswers({ stress_and_anxiety_q2: option });
      navigate(`/quiz/anxiety-3/?si=${si}`);
    }
  };

  const dotDetailsData = [
    {
      title: 'Not at all',
      body: 'My dog enjoys spending time with other dogs',
    },
    {
      title: 'Somewhat',
      body: 'My dog can be nervous or tentative around other dogs and it takes time to build their trust',
    },
    {
      title: 'Significantly',
      body: 'My dog becomes very stressed around unfamiliar dogs',
    },
  ];

  return (
    <section className="min-h-screen bg-dteal-50 pt-24 md:pt-4">
      <div className="container mx-auto flex h-screen flex-col items-center justify-center gap-12">
        <QuizSlideHeading
          before={`Does ${name}`}
          title="Become stressed around other dogs?"
        />

        <div>
          <DotSelector
            data={dotSelectorData}
            option={option}
            setOption={setOption}
            details={dotDetailsData}
          />
          <DotDetails details={dotDetailsData} />
        </div>
        <QuizSlideNavigation
          handleBack={() => navigate(-1)}
          handleNext={handleClick}
        />
      </div>
    </section>
  );
};

export default QuizAnxietyTwo;
